import { BasedObservedViewModel } from "app/based/basedObservedViewModel/BasedObservedViewModel";
import { ESimplifiedBuyingInjection } from "features/eSimplifiedBuyingBeta/di/ESimplifiedBuyingInjection";
import { OrderSimDataFormRequestEntity } from "features/eSimplifiedBuyingBeta/domain/entities/OrderSimDataFormRequestEntity";
import { BehaviorSubject } from "rxjs";
import { injectable } from "tsyringe";
import { strings } from "utils/localizedStrings";
import { IESimplifiedBuyingObservedState } from "../interfaces/IESimplifiedBuying";

class ESimplifiedBuyingInput implements Disposable {
  public orderSimData =
    new BehaviorSubject<OrderSimDataFormRequestEntity>(undefined);

  [Symbol.dispose](): void {
    this.orderSimData.complete();
  }
}

class ESimplifiedBuyingOutput implements Disposable {
  public onError = new BehaviorSubject<string>("");
  public actionSuccess = new BehaviorSubject<string>("");

  [Symbol.dispose](): void {
    this.onError.complete();
    this.actionSuccess.complete();
  }
}

@injectable()
export class ESimplifiedBuyingViewModel extends BasedObservedViewModel<
  ESimplifiedBuyingInput,
  ESimplifiedBuyingOutput,
  IESimplifiedBuyingObservedState
> {
  constructor() {
    super(new ESimplifiedBuyingInput(), new ESimplifiedBuyingOutput());
  }

  private useCase = ESimplifiedBuyingInjection.getUseCase();

  protected override createObservedState(): IESimplifiedBuyingObservedState {
    return {
      loading: false,
      orderResult: null,
    };
  }

  protected override transform(): void {
    this.skipFirstInitial(this.input.orderSimData, async (params) => {
      if (!params) return;

      try {
        this.setObservedState({ loading: true, orderResult: null });
        const res = await this.useCase.orderSimData(params);

        if (res?.data) {
          this.setObservedState({ orderResult: res.data });
          this.output.actionSuccess.next("order");
        }
      } catch (error) {
        console.error(error);
        this.output.onError.next(error?.message || strings.GlobalMessage.Error);
      } finally {
        this.setObservedState({ loading: false });
      }
    });
  }
}
